// Период задачи одним контролом: «−» неделя, Start и End прямо в поле, длина словами, «+» неделя.
// Конец не раньше начала; минус не короче недели.
import { Minus, Plus } from 'lucide-react';
import { addDays, daysBetween, weeksOf, type ISODate } from '@core/dates';
import { cn } from '@core/ui/cn';
import { DateButton } from './RangeControls';

const BTN = 'min-h-0 h-11 w-10 inline-flex items-center justify-center border border-line bg-paper hover:bg-gray-100 disabled:opacity-40 disabled:hover:bg-paper';

export function PeriodField({ start, end, onChange, disabled }: { start: ISODate; end: ISODate; onChange: (start: ISODate, end: ISODate) => void; disabled?: boolean }) {
  const weeks = weeksOf(start, end);
  const days = daysBetween(start, end) + 1;
  const step = (n: number) => onChange(start, addDays(end, 7 * n));
  return (
    <div className="inline-flex w-full" data-period-field>
      <button type="button" className={cn(BTN, 'rounded-l-md')} aria-label="One week shorter" title="One week shorter" disabled={disabled || days <= 7} onClick={() => step(-1)}><Minus className="w-4 h-4" /></button>
      <div className="min-h-0 h-11 flex-1 flex items-center gap-2 border-y border-line bg-paper px-2" data-period-label>
        <DateButton value={start} max={end} label="Start" onChange={(v) => onChange(v, v > end ? v : end)} />
        <span className="text-gray-500">–</span>
        <DateButton value={end} min={start} label="End" onChange={(v) => onChange(start, v)} />
        <span className="ml-auto text-gray-500 text-sm whitespace-nowrap tabular-nums" data-period-length>{weeks} {weeks === 1 ? 'week' : 'weeks'}{days % 7 ? ` · ${days} days` : ''}</span>
      </div>
      <button type="button" className={cn(BTN, 'rounded-r-md')} aria-label="One week longer" title="One week longer" disabled={disabled} onClick={() => step(1)}><Plus className="w-4 h-4" /></button>
    </div>
  );
}
